import React, { useEffect, useState } from 'react'
import { Header } from '../../../components/header/Header'
import { useFormik } from 'formik';
import { CiImageOn } from "react-icons/ci";
import editIcon from "../../../assets/edit_icon.png";
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { Spinner } from '../../../components/spinner/Spinner';
import toast from 'react-hot-toast';
import { addEventThunk, getEventDetailsThunk, delEventThunk } from '../../../slices/events/thunk';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";



export default function CreateEvent() {
  const navigate = useNavigate();
  const [preview, setPreview] = useState(null);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const [isShowSpinner1, setIsShowSpinner1] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isFetchingEvent, setIsFetchingEvent] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams(); // Get encrypted ID from URL params

  const selectUserState = (state) => state.user;
  const userProperties = createSelector(selectUserState, (ecom) => ({
    isSuccess: ecom.isSuccess,
    isLoading: ecom.isLoading,
  }));
  const { isLoading, isSuccess } = useSelector(userProperties);
  const fileUrl = process.env.REACT_APP_FILE_URL;

  const formik = useFormik({
    initialValues: {
      image: null,
      title: "",
      desc: "",
      discount: "",
      from_date: "",
      to_date: "",
      status: "enable"
    },
    // validationSchema: ArtistValidationSchema,
    onSubmit: (values) => {

      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("description", values.desc);
      formData.append("discount", values.discount);
      formData.append("from_date", values.from_date);
      formData.append("to_date", values.to_date);
      formData.append("status", values.status);

      // If editing, send the encrypted ID, otherwise send 0
      formData.append("id", isEditMode ? id : 0);

      if (values.image !== null) {
        
        formData.append("image", values.image);
      } else {
        
      }

      

      setIsShowSpinner(true);

      // Call appropriate thunk based on mode
      if (isEditMode) {
        dispatch(addEventThunk(formData))
          .unwrap()
          .then(() => {
            toast.success('Event updated successfully');
            formik.resetForm();
            setPreview(null);
            navigate(-1);
          })
          .catch((error) => {
           
          })
          .finally(() => {
            setIsShowSpinner(false);
          });
      } else {
        dispatch(addEventThunk(formData))
          .unwrap()
          .then(() => {
            toast.success('Event created successfully');
            formik.resetForm();
            setPreview(null);
            navigate(-1);
          })
          .catch((error) => {
           
          })
          .finally(() => {
            setIsShowSpinner(false);
          });
      }
    },
  });

  // Fetch event details if in edit mode
  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      fetchEventDetails(id);
    }
  }, [id]);

  // Function to fetch event details using your Redux thunk
  const fetchEventDetails = async (encryptedId) => {
    setIsFetchingEvent(true);
    try {
      // Use your getEventDetailsThunk - adjust based on your actual thunk
      var result = await dispatch(getEventDetailsThunk({ id: encryptedId })).unwrap();



      // Adjust these field names based on your API response structure
      var eventData = result.data[0];



      // Populate form with fetched data
      formik.setValues({
        image: null,
        title: eventData.title || "",
        desc: eventData.description || eventData.desc || "",
        discount: eventData.discount || "",
        from_date: eventData.from_date || "",
        to_date: eventData.to_date || "",
        status: eventData.status || "enable"
      });

      // Set image preview if exists
      if (eventData.image) {
        var path = `${fileUrl}/${eventData.image}`
        setPreview(path);
      }

      // toast.success('Event details loaded successfully');
    } catch (error) {
      
      toast.error(error?.message || 'Failed to load event details');
    } finally {
      setIsFetchingEvent(false);
    }
  };


  const deleteEvent = () => {
    var data = {
      id: id
    }
    setIsShowSpinner1(true);
    dispatch(delEventThunk(data))
          .unwrap()
          .then((res) => {
            toast.success('Event deleted successfully');
            navigate(-1);
          })
          .catch((error) => {
          })
          .finally(() => {
            setIsShowSpinner1(false);
          });

  }


  // Handle Image Upload
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue("image", file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Spinner toggle
  useEffect(() => {
    setIsShowSpinner(isLoading || isFetchingEvent);
  }, [isLoading, isFetchingEvent]);

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        <Header title={isEditMode ? "Edit Special Event" : "Add Special Event"} showBack={true} />
      </header>

      <div className="w-full mx-auto">
        {isFetchingEvent ? (
          <div className="w-full flex items-center justify-center py-20">
            <Spinner />
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit} className="w-full">
            <div className="w-full mt-5 border border-border_color p-3 sm:py-5 sm:px-[26px] rounded-[14px]">

              {/* Profile Image */}
              <div className="w-full flex flex-col xs:flex-row items-center justify-center">
                <div className="w-[128px] h-[128px] border border-secondary rounded-full p-2 flex items-center justify-center">
                  <div className="relative w-[117px] h-[117px]">
                    <div className="w-full h-full rounded-full bg-white overflow-hidden flex items-center justify-center">
                      {preview ? (
                        <img
                          src={preview}
                          alt="Profile"
                          className="w-full h-full object-cover object-center"
                        />
                      ) : (
                        <span className="text-gray-500">
                          <CiImageOn className="text-8xl text-gray-300" />
                        </span>
                      )}
                    </div>
                    <input
                      type="file"
                      id="profileUpload"
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={handleImageChange}
                      className="hidden"
                    />
                    <label
                      htmlFor="profileUpload"
                      className="absolute bottom-0 right-0 rounded-full cursor-pointer"
                    >
                      <div className="w-[30px] h-[30px]">
                        <img
                          src={editIcon}
                          alt="edit"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </label>
                  </div>
                </div>
                {formik.errors.image && formik.touched.image && (
                  <p className="text-red-500 text-sm">{formik.errors.image}</p>
                )}
              </div>

              {/* Title & discount */}
              <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px] mt-10">
                <div className="flex flex-col">
                  <label htmlFor="title" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                    Title
                  </label>
                  <input
                    id="title"
                    name="title"
                    type="text"
                    placeholder="Enter event title"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.title}
                    className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                  {formik.errors.title && formik.touched.title && (
                    <p className="text-red-500 text-sm">{formik.errors.title}</p>
                  )}
                </div>

                <div className="flex flex-col">
                  <label htmlFor="discount" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                    Discount (%age)
                  </label>
                  <input
                    id="discount"
                    name="discount"
                    type="number"
                    max="100"
                    min="0"
                    placeholder="Enter discount"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.discount}
                    className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                  {formik.errors.discount && formik.touched.discount && (
                    <p className="text-red-500 text-sm">{formik.errors.discount}</p>
                  )}
                </div>
              </div>

              {/* Description & Status */}
              <div className="w-full grid grid-cols-1 gap-4 mb-[10px]">
                <div className="flex flex-col">
                  <label htmlFor="desc" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                    Description
                  </label>
                  <input
                    id="desc"
                    name="desc"
                    type="text"
                    placeholder="Enter your description"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.desc}
                    className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                  {formik.errors.desc && formik.touched.desc && (
                    <p className="text-red-500 text-sm">{formik.errors.desc}</p>
                  )}
                </div>

                <div className="flex flex-col">
                  <label htmlFor="status" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                    Status
                  </label>
                  <select
                    id="status"
                    name="status"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.status}
                    className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  >
                    <option value="enable">Active</option>
                    <option value="disable">InActive</option>
                  </select>
                  {formik.errors.status && formik.touched.status && (
                    <p className="text-red-500 text-sm">{formik.errors.status}</p>
                  )}
                </div>
              </div>

              {/* Dates */}
              <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mb-[10px]">
                <div className="flex flex-col">
                  <label htmlFor="from_date" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                    Start Date
                  </label>
                  <input
                    id="from_date"
                    name="from_date"
                    type="date"
                    placeholder="Enter event start date"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.from_date}
                    className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                  {formik.errors.from_date && formik.touched.from_date && (
                    <p className="text-red-500 text-sm">{formik.errors.from_date}</p>
                  )}
                </div>
                <div className="flex flex-col">
                  <label htmlFor="to_date" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                    End Date
                  </label>
                  <input
                    id="to_date"
                    name="to_date"
                    type="date"
                    placeholder="Enter event end date"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.to_date}
                    className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                  {formik.errors.to_date && formik.touched.to_date && (
                    <p className="text-red-500 text-sm">{formik.errors.to_date}</p>
                  )}
                </div>
              </div>

              {/* Submit */}
              <div className="w-full flex items-center justify-end mt-4 gap-2">


                <button type="submit" className="flex items-center bg-primary text-white py-3 px-5 rounded-[10px] gap-1">
                  {isShowSpinner ? <Spinner /> : isEditMode ? "Update" : "Create"}
                </button>
                {isEditMode && (
                  <button type='button' onClick={() => deleteEvent(formik.values.id)} className="flex items-center bg-primary text-white py-3 px-5 rounded-[10px] gap-1">
                    {isShowSpinner1 ? <Spinner /> : "Delete"}
                  </button>
                )}
              </div>
            </div>
          </form>
        )}
      </div>
    </>
  )
}